import {Template, TemplateType} from '@/interface';
import {useState, useEffect} from 'react';
import * as store from '@/store';
import sdk from '@/sdk';
import {EDITOR_MODE, STATUS} from '@/Constant';

export interface ITpls {
    userTpls: Template[];
    sysTpls: Template[];
}

export enum DocType {
    nomal = 1,
    card = 2,
    dirty = -1,
}

export default function useTemplateList({
    isCardView,
    mode,
    docGuid,
}: {
    isCardView: boolean;
    mode: string;
    docGuid: string;
}) {
    const [nomalTpls, setNomalTpls] = useState<ITpls>();
    const [cardTpls, setCardTpls] = useState<ITpls>();
    const [curTpls, setCurTpls] = useState<ITpls>();
    const [status, setStatus] = useState('');

    useEffect(() => {
        async function getTemplateList() {
            try {
                const curDocument = store.getCurDocument();
                const repository = store.getData(store.KEYS.CUR_REPOSITORY);
                const parentGuid = curDocument?.rootGuid
                    ? curDocument.rootGuid
                    : curDocument?.parentGuid === '00000000000000' ? '' : curDocument?.parentGuid || '';
                const xWikiAccess = await sdk.as.getWikiAccessToken(
                    repository.spaceGuid,
                    repository.groupGuid,
                    repository.repositoryGuid);
                const tpls = await sdk.as.getDocTemplates(
                    repository.spaceGuid,
                    repository.groupGuid,
                    repository.repositoryGuid,
                    xWikiAccess,
                    parentGuid,
                    0,
                    50,
                    true
                );

                const nomalTplsDataObj: ITpls = {
                    userTpls: [],
                    sysTpls: [],
                };
                const cardTplsDataObj: ITpls = {
                    userTpls: [],
                    sysTpls: [],
                };
                tpls.forEach((tpl: Template) => {
                    const {docType, type, content, name} = tpl;
                    if (content?.children && content?.children.length > 0) {
                        const node = content?.children[0];
                        if (node?.type === 'title') {
                            node?.children[0] && (node.children[0].text = name);
                        }
                    }
                    if (type === TemplateType.User) {
                        nomalTplsDataObj.userTpls.push(tpl);
                        cardTplsDataObj.userTpls.push(tpl);
                    } else {
                        if (docType === DocType.nomal || docType === DocType.dirty) {
                            nomalTplsDataObj.sysTpls.push(tpl);
                        }
                        if (docType === DocType.card || docType === DocType.dirty) {
                            cardTplsDataObj.sysTpls.push(tpl);
                        }
                    }
                });

                setNomalTpls(nomalTplsDataObj);
                setCardTpls(cardTplsDataObj);
            } catch (error) {
                console.log(error);
            } finally {
                setStatus('done');
            }
        }
        const isShowMode = (mode === EDITOR_MODE.edit || mode === EDITOR_MODE.meeting || mode === EDITOR_MODE.normal);
        if (isShowMode && !window.isTocPage) {
            getTemplateList();
        }
    }, [mode, docGuid]);

    useEffect(() => {
        setCurTpls(isCardView ? cardTpls : nomalTpls);

    }, [cardTpls, isCardView, nomalTpls]);

    return {
        curTpls,
        status,
    };
}
